import React from "react";
import {
  clickStreamUser,
  goToLPDetailUtil,
} from "../../../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

import { useSelector } from "react-redux";

const ActionPathCard = ({ index, action }) => {
  const navigate = useNavigate();
  const authBroker = useSelector((state) => state.auth.authBroker);

  return (
    <div
      key={index}
      className={`action-path-slide cursor-pointer`}
      onClick={() => {
        clickStreamUser(
          "action_path_banner_clicked",
          {
            userId: authBroker?.payload?.user?.user_id,
            title: action?.lp_name,
          },
          authBroker,
        );
        goToLPDetailUtil(action, navigate, 1);
      }}
      tabIndex="0"
      aria-label="Action Path"
    >
      {!_.isEmpty(action?.cover_url) ? (
        // <img className='action-path-box-img img-fluid' src={action?.cover_url} alt="Action Path" tabIndex="0" aria-lable="Action Path"/>:
        <div className={`action-path-box position-relative`}>
          <div className="img-box-pat">
            <img
              src={action?.cover_url}
              alt="action path"
              className="img-fluid"
            />
          </div>
          <div className="content-box-pat">
            <h3 title={action.lp_name} aria-label={action.lp_name}>
              {action.lp_name}
            </h3>
            <p
              title={action.category_name?.replace(/<[^>]+>/g, "")} // remove HTML tags for title
              dangerouslySetInnerHTML={{ __html: action.category_name }}
            ></p>
          </div>
        </div>
      ) : (
        //         <div
        //   className="action-path-box position-relative d-flex flex-column overflow-hidden"
        //   style={{
        //     height: "320px",
        //     borderRadius: "16px",
        //     background: "#fff",
        //   }}
        // >
        //   <div
        //     className="img-box-pat flex-shrink-0 overflow-hidden"
        //     style={{
        //       height: "180px",
        //       width: "100%",
        //     }}
        //   >
        //     <img
        //       src={action?.cover_url}
        //       alt="action path"
        //       className="w-100 h-100 d-block"
        //       style={{
        //         objectFit: "cover",
        //       }}
        //     />
        //   </div>

        //   <div
        //     className="content-box-pat d-flex flex-column justify-content-between flex-grow-1 p-3"
        //   >
        //     <h3
        //       title={action.lp_name}
        //       aria-label={action.lp_name}
        //       style={{
        //         fontSize: "18px",
        //         lineHeight: "1.3",
        //         overflow: "hidden",
        //         display: "-webkit-box",
        //         WebkitLineClamp: 2,
        //         WebkitBoxOrient: "vertical",
        //       }}
        //     >
        //       {action.lp_name}
        //     </h3>

        //     <p
        //       title={action.category_name?.replace(/<[^>]+>/g, "")}
        //       dangerouslySetInnerHTML={{ __html: action.category_name }}
        //       style={{
        //         overflow: "hidden",
        //         textOverflow: "ellipsis",
        //         display: "-webkit-box",
        //         WebkitLineClamp: 2,
        //         WebkitBoxOrient: "vertical",
        //       }}
        //     ></p>
        //   </div>
        // </div>
        <></>
      )}
      {false && (
        <div className={`action-path-box ${action.color}`}>
          <div className="img-box-pat">
            <img
              src={action.thumbnail}
              alt="action path"
              className="img-fluid"
            />
          </div>
          <div className="content-box-pat">
            <h3>{action.lp_name}</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: action.category_name,
              }}
            ></p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionPathCard;
